import { render, staticRenderFns } from "./transports.vue?vue&type=template&id=9b8164e0&"
import script from "./transports.vue?vue&type=script&lang=js&"
export * from "./transports.vue?vue&type=script&lang=js&"
import style0 from "./transports.vue?vue&type=style&index=0&id=9b8164e0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports